import axios from 'axios';
// import store from '../store';
import crud from "./crud";
import moment from 'moment';
const { VUE_APP_ERP_BASE_API } = process.env;

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}
const baseurl = 'collection';
export default {
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'compcode', 'crewnik', 'crewname', 'jabatan', 'departemen', 'pangkat', 'golongan', 'managerinfo', 'terminate', 'officer'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/crew${str}`;
                const { data } = await axios({ url, baseURL: VUE_APP_ERP_BASE_API });
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                console.log('Error >> ', error)
                errorHandler(error, reject)
            }
        })
    },
    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/crew`;
                await axios({ method: 'post', url, baseURL: VUE_APP_ERP_BASE_API, data: obj })
                resolve(true);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    detail({ crewkey }) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/crew/detail/${crewkey}`;
                const { data } = await axios({ url, baseURL: VUE_APP_ERP_BASE_API });
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    remove({ crewkey }) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/crew/${crewkey}`;
                const resp = await axios({ method: 'delete', url, baseURL: VUE_APP_ERP_BASE_API })
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    exportxls(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'customer', 'collectability', 'collector_id', 'model_pinjaman', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/crew/exportxls${str}`;
                axios({
                    url: url,
                    baseURL: VUE_APP_ERP_BASE_API,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'employee-collection.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    saveAssignment(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post(`${baseurl}/assignment`, obj);
                console.log('data >> ', data);
                resolve(true)
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    assignment(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'compcode', 'crewnik', 'crewname', 'jabatan', 'departemen', 'pangkat', 'golongan', 'managerinfo', 'terminate', 'officer'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `${baseurl}/assignment${str}`;
                const { data } = await axios.get(url)
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                console.log('Error >> ', error)
                errorHandler(error, reject)
            }
        })
    },
    // importdtxls(filexls, obj) {
    //     return new Promise(async (resolve, reject) => {
    //         try {
    //             const fd = new FormData();
    //             fd.append('fileXlsx', filexls, filexls.name);
    //             for (const key in obj) {
    //                 fd.append(key, obj[key]);
    //             }
    //             const { data } = await axios.post(`${baseurl}/importdtxls`, fd);
    //             resolve(data);
    //         } catch (error) {
    //             errorHandler(error, reject)
    //         }
    //     });
    // },
    // savebulk(arr) {
    //     return new Promise(async (resolve, reject) => {
    //         try {
    //             await axios.post(`${baseurl}/savebulk`, arr);
    //             resolve();
    //         } catch (error) {
    //             errorHandler(error, reject)
    //         }
    //     })
    // },
    saveActivity(dtset) {
        return new Promise(async (resolve, reject) => {
            try {
                const result = await axios.post(`${baseurl}/activity`, dtset);
                resolve(true)
            } catch (error) {
                reject(error)
            }
        })
    },
    collectorActivity(nasabahkey) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`${baseurl}/collector-activity/${nasabahkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    // golongankolektor() {
    //     return new Promise(async (resolve, reject) => {
    //         try {
    //             const {data} = await axios.get(`${baseurl}/golongan-kolektor`);
    //             resolve(data);
    //         } catch (error) {
    //             errorHandler(error, reject)
    //         }
    //     })
    // },
    report(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tgl'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const { data } = await axios.get(`${baseurl}/report${str}`);
                const { meta, list } = data;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    exportxlsreport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tgl'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/exportxls-report/${str}`;
                // await axios.get(`${url}`);

                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `reportcollection_${obj.tgl}_${moment().format('YYYYMMDDHHMMSS')}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                })
                    .catch(e => {
                        console.log('e', e.response.status);
                        console.log(JSON.stringify(e.response.status));
                        if (e.response.status == 404) {
                            errorHandler('Data empty,Please Re-Check or REPROCESS', reject)
                        } else {
                            errorHandler(e, reject)
                        }
                    });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    reportInstallment(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tgl', 'pjxkey'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const { data } = await axios.get(`${baseurl}/report-installment${str}`);
                const { meta, list } = data;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    exportxlsreportInstallment(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tgl','pjxkey','pjxcode','pjxname'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/exportxls-report-installment/${str}`;
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `reportcollection_${obj.pjxcode}_${obj.tgl}_${moment().format('YYYYMMDDHHMMSS')}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                })
                    .catch(e => {
                        console.log('e', e.response.status);
                        console.log(JSON.stringify(e.response.status));
                        if (e.response.status == 404) {
                            errorHandler('Data empty,Please Re-Check or REPROCESS', reject)
                        } else {
                            errorHandler(e, reject)
                        }
                    });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    processreportbyloan(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post(`${baseurl}/report-by-loan`, obj);
                const { meta, list } = data;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    reportbyloan(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tgl'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const { data } = await axios.get(`${baseurl}/report-by-loan${str}`);
                const { meta, list } = data;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    exportxlsreportbyloan(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['tgl'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/exportxls-report-byloan/${str}`;
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    console.log('response', response)
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `reportcollectionbyloan_${obj.tgl}_${moment().format('YYYYMMDDHHMMSS')}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                })
                    .catch(e => {
                        console.log('e', e.response.status);
                        console.log(JSON.stringify(e.response.status));
                        if (e.response.status == 404) {
                            errorHandler('Data empty,Please Re-Check or REPROCESS', reject)
                        } else {
                            errorHandler(e, reject)
                        }
                    });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    reportbydebitur(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tgl'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const { data } = await axios.get(`${baseurl}/report-by-debitur${str}`);
                const { meta, list } = data;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
}